import React from 'react';

export function DotsConnector() {
  return (
    <div className="flex gap-[10px] items-center">
      <div className="size-[6px] rounded-full bg-muted opacity-50" />
      <div className="size-[6px] rounded-full bg-muted opacity-50" />
      <div className="size-[6px] rounded-full bg-muted opacity-50" />
    </div>
  );
}
